


































import Vue from "vue";
import ConnectedDeviceEdit from "@/components/ConnectedDevice/ConnectedDeviceEdit.vue";
import ConnectedDeviceAdd from "@/components/ConnectedDevice/ConnectedDeviceAdd.vue";
import { Grid } from "@progress/kendo-vue-grid";
import { Info } from "@/models/Info";
import { ConnectedDevice } from "@/models/ConnectedDevice";
import { CloudSetting } from "@/models/CloudSetting";

function getNestedValue(fieldName: string, dataItem) {
  const path = fieldName.split(".");
  let data = dataItem;
  path.forEach(p => {
    data = data ? data[p] : undefined;
  });
  if (fieldName === "mode") {
    return getModeName(dataItem.mode);
  } else {
    return data;
  }
}
function getModeName(code) {
  switch (code) {
    case 1:
      return "Master";
    case 2:
      return "Slave";
    case 3:
      return "KDS";
    case 4:
      return "Table Ordering";
    case 5:
      return "Customer Screen";
    case 6:
      return "ANZ Blade";
    default:
      break;
  }
}

export default Vue.extend({
  props: {
    info: {
      type: Object as () => Info,
      default: null
    }
  },
  components: {
    Grid,
    ConnectedDeviceEdit,
    ConnectedDeviceAdd
  },
  computed: {
    computeDevice(): ConnectedDevice[] {
      const result = this.info.cloudSettings.filter(cd => cd.deviceUDID == this.info.selectedDevice.deviceUDID)[0];
      if (result && result.connectedDevicesList) {
        return Object.values(result.connectedDevicesList);
      } else {
        return [];
      }
    },
    selectedDevice(): CloudSetting {
      return this.info.selectedDevice;
    }
  },
  data() {
    return {
      editItem: null as ConnectedDevice | null,
      isEditMode: false,
      isAddMode: false,
      columns: [
        { field: "ipAddress", title: "Ip Address" },
        { field: "isAuthorized", title: "Authorized" },
        { field: "isConnected", title: "Connected" },
        { field: "mode", title: "Mode" },
        {
          field: "Action",
          title: " ",
          width: "75"
        }
      ]
    };
  },
  methods: {
    getNestedValue,
    onEditBtnClick(dataItem: ConnectedDevice): any {
      const foundItems = this.computeDevice.map(sett => {
        return sett.id;
      });
      const selectedIndex = foundItems.indexOf(dataItem.id);
      const item = this.computeDevice[selectedIndex];
      this.editItem = {
        ...item
      };

      this.isEditMode = true;
    },
    onAddBtnClick(dataItem: ConnectedDevice): any {
      this.isAddMode = true;
    },
    handleEditSuccess(data: ConnectedDevice) {
      // if (data.id === this.computeDevice.length) {
      //   const model = { id: data.id };
      //   this.computeDevice.push(model as any);
      // }
      // this.computeDevice[data.id].ipAddress = data.ipAddress;
      // this.computeDevice[data.id].isAuthorized = data.isAuthorized;
      // this.computeDevice[data.id].isAuthorized = data.isAuthorized;
      // this.computeDevice[data.id].mode = data.mode;
      // this.computeDevice[data.id].isRegisterAtSlave = data.isRegisterAtSlave;
      // this.computeDevice[data.id].isSelf = data.isSelf;
      this.$emit("refresh");
      return;
    }
  }
});
